class TxtType {
    constructor(element, words) {
        this.element = element;
        this.words = words;
        this.loopIndex = 0;
        this.text = "";
        this.isDeleting = false;
        this.delta = 500;
        this.element = element;
        this.words = words;
        this.loopIndex = 0;
        this.text = "";
        this.isDeleting = false;
        this.delta = 500;
        this.tick();
    }
    tick() {
        if (!this.words.length) {
            return;
        }
        const index = this.loopIndex % this.words.length;
        const fullText = this.words[index];
        if (this.isDeleting) {
            this.text = fullText.substring(0, this.text.length - 1);
        }
        else {
            this.text = fullText.substring(0, this.text.length + 1);
        }
        const wrapper = document.createElement("span");
        wrapper.classList.add("wrap");
        wrapper.textContent = this.text;
        this.element.replaceChildren(wrapper);
        if (!this.isDeleting
            && this.text === fullText) {
            this.delta = 1500;
            this.isDeleting = true;
        }
        else if (!this.isDeleting
            && this.text !== fullText) {
            this.delta = 100;
        }
        else if (this.isDeleting
            && this.text === "") {
            this.isDeleting = false;
            this.loopIndex += 1;
            this.delta = 500;
        }
        else {
            this.delta = 100;
        }
        window.setTimeout(() => this.tick(), this.delta);
    }
}
/**
 * Creates the word-by-word animation.
 *
 * Returns animation duration in milliseconds,
 * so following elements can be started afterwards.
 */
const animateWords = (element, text, { tagName = "span", initialDelay = 500, wordDelay = 100, } = {}) => {
    if (!element || !text) {
        return 0;
    }
    const words = text
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    element.innerHTML = "";
    element.style.overflow = "hidden";
    words.forEach((word, index) => {
        const span = document.createElement(tagName);
        span.textContent =
            `${word}${index < words.length - 1 ? " " : ""}`;
        span.style.opacity = "0";
        span.style.transitionDuration = "1s";
        span.style.position = "relative";
        span.style.top = "20px";
        element.appendChild(span);
        window.setTimeout(() => {
            span.style.opacity = "1";
            span.style.top = "0";
            span.classList.add("animate");
        }, initialDelay + wordDelay * index);
    });
    return (initialDelay
        + words.length * wordDelay);
};
/**
 * TYPEWRITER
 */
const initializeTypewriters = () => {
    const elements = document.querySelectorAll(".typewrite");
    elements.forEach((element) => {
        const rawText = element.dataset.txt;
        if (!rawText) {
            return;
        }
        const words = rawText
            .split(",")
            .map((word) => word.trim())
            .filter(Boolean);
        if (!words.length) {
            return;
        }
        new TxtType(element, words);
    });
};
/**
 * HERO TEXT ANIMATION
 */
const initializeHeroTextAnimation = () => {
    const heading = document.querySelector("[data-text]");
    if (!heading) {
        initializeTypewriters();
        return;
    }
    const subheading = document.querySelector("[data-subheading]");
    const headingText = heading.dataset.text;
    if (!headingText) {
        return;
    }
    const headingDuration = animateWords(heading, headingText, {
        initialDelay: 500,
        wordDelay: 100,
    });
    let subheadingDuration = 0;
    if (subheading
        && subheading.dataset.subheading) {
        subheadingDuration =
            animateWords(subheading, subheading.dataset.subheading, {
                tagName: "small",
                initialDelay: headingDuration,
                wordDelay: 100,
            });
    }
    window.setTimeout(initializeTypewriters, Math.max(headingDuration, subheadingDuration));
};
/**
 * SECTION ANIMATION
 */
const animateSection = (section) => {
    const heading = section.querySelector("[data-heading]");
    if (!heading) {
        return;
    }
    const description = section.querySelector("[data-desc]");
    const button = section.querySelector("[data-button]");
    const headingText = heading.dataset.heading;
    if (!headingText) {
        return;
    }
    const duration = animateWords(heading, headingText, {
        initialDelay: 100,
        wordDelay: 100,
    });
    if (description) {
        window.setTimeout(() => {
            description.style.opacity = "1";
        }, duration);
    }
    if (button) {
        window.setTimeout(() => {
            button.style.opacity = "1";
        }, duration + 500);
    }
};
const initializeSectionAnimations = () => {
    const sections = document.querySelectorAll("[data-animation]");
    if (!sections.length) {
        return;
    }
    /**
     * Fallback for very old browsers.
     */
    if (!("IntersectionObserver" in window)) {
        sections.forEach(animateSection);
        return;
    }
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }
            animateSection(entry.target);
            /**
             * Run only once.
             */
            observer.unobserve(entry.target);
        });
    }, {
        /**
         * Similar behaviour to the old:
         * window.innerHeight > top + 150
         */
        rootMargin: "0px 0px -150px 0px",
        threshold: 0,
    });
    sections.forEach((section) => {
        observer.observe(section);
    });
};
export const initializeAnimations = () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
        return;
    initializeHeroTextAnimation();
    initializeSectionAnimations();
};
